module.exports = __webpack_public_path__ + "img/B67F6B_4B2E2A_6C3A34_F3DBC6-256px.341559cf.png";